import { formatDateLabel, formatNumberFixed, formatUsdCompact, formatZec } from "@/lib/cypherpunk/format";
import type { CypherpunkTrackerPayload } from "@/types/cypherpunkTrackerData";

export default function TopMetricLozenges({
  data,
}: {
  data: CypherpunkTrackerPayload;
}): React.ReactElement {
  const firstPurchaseDate = formatDateLabel(data.summary.firstPurchaseDate);

  return (
    <div className="cyph-top-lozenges">
      <div className="cyph-top-lozenge">
        <div className="cyph-top-lozenge-label">Cyph target</div>
        <div className="cyph-top-lozenge-value">
          <span className="cyph-num">{formatNumberFixed(data.goal.targetPct)}</span>%
        </div>
        <div className="cyph-top-lozenge-sub">Network ownership</div>
      </div>

      <div className="cyph-top-lozenge">
        <div className="cyph-top-lozenge-label">Days since 1st buy</div>
        <div className="cyph-top-lozenge-value">
          <span className="cyph-num">{data.summary.daysSinceFirstBuy.toLocaleString("en-US")}</span>
        </div>
        <div className="cyph-top-lozenge-sub">since {firstPurchaseDate}</div>
      </div>

      <div className="cyph-top-lozenge">
        <div className="cyph-top-lozenge-label">Total ZEC</div>
        <div className="cyph-top-lozenge-value">
          <span className="cyph-num">{formatZec(data.summary.totalZecHeld)}</span>
        </div>
        <div className="cyph-top-lozenge-sub">
          ~<span className="cyph-num">{formatUsdCompact(data.display.reserveValueUsd)}</span> at current price
        </div>
      </div>

      <div className="cyph-top-lozenge">
        <div className="cyph-top-lozenge-label">Total $ deployed</div>
        <div className="cyph-top-lozenge-value">
          <span className="cyph-num">{formatUsdCompact(data.summary.totalCostUsd)}</span>
        </div>
        <div className="cyph-top-lozenge-sub">
          Avg cost:{" "}
          {data.summary.avgCostBasisUsd != null ? (
            <span className="cyph-num">{formatUsdCompact(data.summary.avgCostBasisUsd)}</span>
          ) : (
            "—"
          )}{" "}
          per ZEC
        </div>
      </div>
    </div>
  );
}
